import moment from "moment-timezone";

import { startCase, toLower } from "lodash";
import { getFirstName, getLastName } from "./sessionStorage";

import Chip from "@material-ui/core/Chip";

import {
  ORDER_TYPE_PROP_2_PACK,
  ORDER_TYPE_PROP_2_PACK_FOLLOW_UP,
  ORDER_TYPE_PROP_1_PACK,
  ORDER_TYPE_PROP_1_PACK_FOLLOW_UP,
  ORDER_TYPE_PROP_VISIT_ONLY,
  ORDER_TYPE_PROP_VISIT_ONLY_FOLLOW_UP,
  ORDER_TYPE_PROP_1_PACK_FLAVORED,
  ORDER_TYPE_PROP_2_PACK_FLAVORED,
  ORDER_TYPE_PROP_1_PACK_FLAVORED_FOLLOW_UP,
  ORDER_TYPE_PROP_2_PACK_FLAVORED_FOLLOW_UP,
  ORDER_TYPE_PROP_TRIAL_PACK_FLAVORED,
  VISIT_TYPE_PERFORMANCE_ANXIETY,
  VISIT_TYPE_PERFORMANCE_ANXIETY_FOLLOW_UP,
  VISIT_TYPE_INSOMNIA,
  VISIT_TYPE_INSOMNIA_FOLLOW_UP,
  COLOR_KICK_LIGHT_BLUE,
  COLOR_KICK_LIGHT_PINK,
  ORDER_TYPE_SLEEP_MEMBERSHIP_MAIL_ORDER_MONTHLY,
  ORDER_TYPE_SLEEP_MEMBERSHIP_MAIL_ORDER_QUARTERLY,
  ORDER_TYPE_SLEEP_MEMBERSHIP_MAIL_ORDER_SEMIANNUAL,
  ORDER_TYPE_SLEEP_MEMBERSHIP_MAIL_ORDER_FOLLOW_UP,
  ORDER_TYPE_SLEEP_MEMBERSHIP_VISIT_ONLY_MONTHLY,
  ORDER_TYPE_SLEEP_MEMBERSHIP_VISIT_ONLY_QUARTERLY,
  ORDER_TYPE_SLEEP_MEMBERSHIP_VISIT_ONLY_SEMIANNUAL,
  ORDER_TYPE_SLEEP_MEMBERSHIP_VISIT_ONLY_FOLLOW_UP,
  ORDER_TYPE_SLEEP_RX_TRIAL_MAIL_ORDER_ONE_MONTH,
  ORDER_TYPE_SLEEP_RX_TRIAL_MAIL_ORDER_TWO_MONTHS,
  ORDER_TYPE_SLEEP_RX_TRIAL_VISIT_ONLY_ONE_MONTH,
  ORDER_TYPE_SLEEP_RX_TRIAL_VISIT_ONLY_TWO_MONTHS,
  ORDER_TYPE_SCOPOLAMINE_ADDON_4_PACK_MAIL_ORDER,
  ORDER_TYPE_SCOPOLAMINE_ADDON_10_PACK_MAIL_ORDER,
  ORDER_TYPE_SCOPOLAMINE_ADDON_4_PACK_VISIT_ONLY,
} from "~/shared/sharedConstants";

export function displayGender(value) {
  switch (value) {
    case "M":
      return "Male";
    case "F":
      return "Female";
    case "X":
      return "Unspecified Gender";
    default:
      return "{UNKNOWN GENDER}";
  }
}

export function displayVisitType(visitType) {
  switch (visitType) {
    case VISIT_TYPE_PERFORMANCE_ANXIETY:
      return "Performance Anxiety 🎤️";
    case VISIT_TYPE_PERFORMANCE_ANXIETY_FOLLOW_UP:
      return "Performance Anxiety - Follow Up 🎤️";
    case VISIT_TYPE_INSOMNIA:
      return "Insomnia 💤";
    case VISIT_TYPE_INSOMNIA_FOLLOW_UP:
      return "Insomnia - Follow Up 💤";
  }
}

export function displayVisitTypeNoEmoji(visitType) {
  switch (visitType) {
    case VISIT_TYPE_PERFORMANCE_ANXIETY:
      return "Performance Anxiety";
    case VISIT_TYPE_PERFORMANCE_ANXIETY_FOLLOW_UP:
      return "Performance Anxiety - Follow Up";
    case VISIT_TYPE_INSOMNIA:
      return "Insomnia";
    case VISIT_TYPE_INSOMNIA_FOLLOW_UP:
      return "Insomnia - Follow Up";
  }
}

export function displayOrderTypeShort(visitOrderType) {
  switch (visitOrderType) {
    case ORDER_TYPE_PROP_VISIT_ONLY:
      return "Pickup";
    case ORDER_TYPE_PROP_1_PACK:
      return "1 Pack";
    case ORDER_TYPE_PROP_2_PACK:
      return "2 Pack";
    case ORDER_TYPE_PROP_VISIT_ONLY_FOLLOW_UP:
      return "Pickup Follow";
    case ORDER_TYPE_PROP_1_PACK_FOLLOW_UP:
      return "1pk Follow";
    case ORDER_TYPE_PROP_2_PACK_FOLLOW_UP:
      return "2pk Follow";
    case ORDER_TYPE_PROP_1_PACK_FLAVORED:
      return "1pk Flavored";
    case ORDER_TYPE_PROP_2_PACK_FLAVORED:
      return "2pk Flavored";
    case ORDER_TYPE_PROP_1_PACK_FLAVORED_FOLLOW_UP:
      return "1pk Flavored Follow";
    case ORDER_TYPE_PROP_2_PACK_FLAVORED_FOLLOW_UP:
      return "2pk Flavored Follow";
    case ORDER_TYPE_PROP_TRIAL_PACK_FLAVORED:
      return "Sample Pack Flavored";
    default:
      return `{UNKNOWN VISIT ORDER TYPE: ${visitOrderType}}`;
  }
}

export function displayAge(birthday) {
  return moment.utc().diff(birthday, "years");
}
export function displayLongFormattedDateTime(date) {
  return moment.utc(date).format("llll");
}
export function displayShortFormattedDateTime(date) {
  return moment.utc(date).format("lll");
}
export function displayDateOnly(date) {
  return moment.utc(date).format("LL");
}
export function displayLongFormattedDateTimePacific(date) {
  return moment.tz(date, "America/Los_Angeles").format("llll z");
}
export function displayShortFormattedDateTimePacific(date) {
  return moment.tz(date, "America/Los_Angeles").format("lll z");
}
export function displayCapitalize(str) {
  return startCase(toLower(str));
}
export function displayShortDate(date) {
  return moment.utc(date).format("MM/YYYY");
}
export function displayLongDate(date) {
  return moment.utc(date).format("MM/DD/YYYY");
}

export function displayPhoneNumber(phoneNumberString) {
  var cleaned = ("" + phoneNumberString).replace(/\D/g, "");
  var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    return match[1] + "-" + match[2] + "-" + match[3];
  }
  return phoneNumberString;
}

export function displayPhoneNumberParens(phoneNumberString) {
  var cleaned = ("" + phoneNumberString).replace(/\D/g, "");
  var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    return "(" + match[1] + ") " + match[2] + "-" + match[3];
  }
  return phoneNumberString;
}

export function displayMyFullNameFromSession() {
  return displayCapitalize(`${getFirstName()} ${getLastName()}`);
}

// export function displayImage(url) {
//   {
//     return axios
//       .get(url, {
//         responseType: "arraybuffer"
//       })
//       .then(response => new Buffer(response.data, "binary").toString("base64"));
//   }
// }

export function displayVisitStatus(status) {
  switch (status) {
    case "N":
      return "New";
    case "C":
      return "Patient Completed";
    case "R":
      return "Ready";
    case "P":
      return "Pending";
    case "PRAD":
      return "Pending Review Admin";
    case "PA":
      return "Missing Payment";
    case "PP":
      return "Missing Photos";
    case "PV":
      return "Pending Verification";
    case "PR":
      return "Awaiting Patient Reply";
    case "PT":
      return "Missing Photos - Retake";
    case "CC":
      return "Closed - Complete";
    case "CE":
      return "Closed - Error";
    case "CP":
      return "Closed - Referral PCP";
    case "CU":
      return "Closed - Referral Urgent";
    case "CPU":
      return "Closed - Payment Uncollectable";
    case "CR":
      return "Closed - Refunded";
    case "CL":
      return "Closed - Cancelled";
    case "CD":
      return "Closed - Duplicate";
    case "CS":
      return "Closed - Spam";
    case "CO":
      return "Closed - Other";
  }
  return "Status Unknown";
}

export function displayVisitNoteDisposition(disposition) {
  switch (disposition) {
    case "ROUTINE_VISIT":
      return "Routine Visit";
    case "REFERRAL_PRIMARY":
      return "Referral - PCP";
    case "REFERRAL_URGENT":
      return "Referral - Urgent";
    case "AWAITING_PATIENT_REPLY":
      return "Awaiting Reply";
    case "DUPLICATE_VISIT":
      return "Closed - Duplicate";
    case "REFUND_REQUESTED":
      return "Closed - Refund";
    case "PAYMENT_UNCOLLECTABLE":
      return "Closed - Payment Uncollectable";
    case "CANCELATION_REQUESTED":
      return "Closed - Cancelled";
    case "SPAM":
      return "Closed - Spam";
    case "OTHER":
      return "Other";
    case "ERROR":
      return "Error";
  }
}

export function displayVisitNoteDispositionChip(disposition) {
  const label = displayVisitNoteDisposition(disposition);
  switch (disposition) {
    case "ROUTINE_VISIT":
      return generateChip(label, "#30544f", "white");
    case "REFERRAL_PRIMARY":
      return generateChip(label, "#ffdd00", "#3f3f82");
    case "REFERRAL_URGENT":
      return generateChip(label, "#ffdd00", "#f25930");
    case "AWAITING_PATIENT_REPLY":
      return generateChip(label, "#ffb7ad", "#1e2347");
    case "DUPLICATE_VISIT":
      return generateChip(label, "#dddddd", "#1e2347");
    case "REFUND_REQUESTED":
      return generateChip(label, "#f25930", "white");
    case "PAYMENT_UNCOLLECTABLE":
      return generateChip(label, "#f25930", "white");
    case "CANCELATION_REQUESTED":
      return generateChip(label, "#f25930", "white");
    case "SPAM":
      return generateChip(label, "#8096ab", "#3f3f82");
    case "OTHER":
      return generateChip(label, "#8096ab", "#3f3f82");
    case "ERROR":
      return generateChip(label, "#8096ab", "#3f3f82");
  }
}
export function displayVisitStatusChip(visitStatus) {
  const label = displayVisitStatus(visitStatus);
  switch (visitStatus) {
    case "N":
      return generateChip(label, "#8096ab", "white");
    case "R":
      return generateChip(label, "#3f3f82", "white");
    case "P":
      return generateChip(label, "#ffb7ad", "white");
    case "PRAD":
      return generateChip(label, "#e0adff", "1e2347");
    case "PR":
      return generateChip(label, "#ffb7ad", "#1e2347");
    case "CC":
      return generateChip(label, "#30544f", "white");
    case "PA":
      return generateChip(label, "#ffb7ad", "#1e2347");
    case "PP":
      return generateChip(label, "#ffb7ad", "white");
    case "PV":
      return generateChip(label, "#ffb7ad", "white");
    case "CP":
      return generateChip(label, "#ffdd00", "#3f3f82");
    case "CU":
      return generateChip(label, "#ffdd00", "#f25930");
    case "CD":
      return generateChip(label, "#dddddd", "#1e2347");
    case "CS":
      return generateChip(label, "#8096ab", "#3f3f82");
    case "CPU":
      return generateChip(label, "#f25930", "white");
    case "CR":
      return generateChip(label, "#f25930", "white");
    case "CL":
      return generateChip(label, "#f25930", "white");

    default:
      return generateChip(label, "#dddddd", "#1e2347");
  }
}
export function displayOrderTypeChip(orderType) {
  const label = displayOrderTypeShort(orderType);
  switch (orderType) {
    case ORDER_TYPE_PROP_2_PACK:
    case ORDER_TYPE_PROP_2_PACK_FOLLOW_UP:
      return generateChip(label, "#f2f9f7", "#1e2347");
    case ORDER_TYPE_PROP_1_PACK:
    case ORDER_TYPE_PROP_1_PACK_FOLLOW_UP:
      return generateChip(label, "#fff7e5", "#1e2347");
    case ORDER_TYPE_PROP_VISIT_ONLY:
    case ORDER_TYPE_PROP_VISIT_ONLY_FOLLOW_UP:
      return generateChip(label, "#ffdd00", "#1e2347");
    case ORDER_TYPE_PROP_1_PACK_FLAVORED:
    case ORDER_TYPE_PROP_2_PACK_FLAVORED:
      return generateChip(label, "#f2f9f7", "#1e2347");
    case ORDER_TYPE_PROP_1_PACK_FLAVORED_FOLLOW_UP:
    case ORDER_TYPE_PROP_2_PACK_FLAVORED_FOLLOW_UP:
      return generateChip(label, "#f2f9f7", "#1e2347");
  }
}
function generateChip(label, backgroundColor, color) {
  return (
    <Chip
      style={{
        backgroundColor: backgroundColor,
        color: color,
        fontFamily: "BasisGrotesquePro-Regular",
        margin: "2px",
      }}
      label={label}
    />
  );
}

export function isPickupOrder(visitOrderType) {
  switch (visitOrderType) {
    case ORDER_TYPE_PROP_VISIT_ONLY:
      return true;
    default:
      return false;
  }
}

export function visitSummaryBackgroundColor(visitType) {
  switch (visitType) {
    case VISIT_TYPE_PERFORMANCE_ANXIETY:
    case VISIT_TYPE_PERFORMANCE_ANXIETY_FOLLOW_UP:
      return COLOR_KICK_LIGHT_PINK;

    case VISIT_TYPE_INSOMNIA:
    case VISIT_TYPE_INSOMNIA_FOLLOW_UP:
      return COLOR_KICK_LIGHT_BLUE;
  }

  return COLOR_KICK_LIGHT_BLUE;
}
